import moment from 'moment';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import {
  getPersistentItem, saveAppState, savePersistentItem, testLocalStorageSupport,
} from 'utils/localRepository';
import * as actionTypes from 'actions/actionTypes';

const loggerMiddleware = (store) => (next) => (action) => {
  if (!testLocalStorageSupport()) {
    return next(action);
  }

  const saveKeyToLocalStorage = (key, value) => {
    const storeState = store.getState();
    const data = {
      ...getPersistentItem(storeState.loan.id),
      [key]: value,
    };
    savePersistentItem(storeState.loan.id, data);
  };

  if (action.type === actionTypes.SAVE_LOAN_STATE) {
    const storeState = store.getState();
    const loan = merge({}, storeState.loan);
    let loanFormValues;
    if (storeState.form.loan) {
      loanFormValues = merge({}, storeState.form.loan.values);
    }
    const content = {
      loan,
      loanFormValues,
      timestamp: moment().format(),
    };
    const id = storeState.authentication.identifier;
    if (!isEmpty(loanFormValues) && !isEqual(loan.formInitalValues, loanFormValues) && id) {
      saveAppState(id, content);
    }
  }

  if (
    action.type === actionTypes.SAVE_EID_RESULT_SUCCESS
    || action.type === actionTypes.SKIP_EID
  ) {
    saveKeyToLocalStorage('eidSucceeded', true);
  }

  if (
    action.type === actionTypes.PUT_KONTOMATIK_SESSION_SUCCESS
    || action.type === actionTypes.SKIP_KONTOMATIK
  ) {
    saveKeyToLocalStorage('kontomatikSuccess', true);
  }

  if (action.type === actionTypes.SKIP_BANK_STATEMENTS) {
    saveKeyToLocalStorage('bankStatementSkipped', true);
  }

  if (action.type === actionTypes.POST_BANK_STATEMENTS_SUCCESS) {
    saveKeyToLocalStorage('bankStatementSuccess', true);
  }

  if (action.type === actionTypes.PUT_CALMA_SUCCESS) {
    saveKeyToLocalStorage('calmaPassed', true);
  }

  if (action.type === actionTypes.SKIP_CALMA) {
    saveKeyToLocalStorage('calmaPassed', true);
  }

  if (action.type === actionTypes.CALMA_AVAILABILITY_SUCCESS) {
    const { CALMA } = action.result.data;
    if (!CALMA || !CALMA.isAvailable || CALMA.enabled) {
      // If Calma is unavailable, or already enabled, the page auto-redirects. Mark it as passed.
      saveKeyToLocalStorage('calmaPassed', true);
    }
  }

  if (action.type === actionTypes.SKIP_LIBERTO) {
    const storeState = store.getState();
    if (COUNTRY !== 'ES' || storeState.loan.popupShowed) {
      saveKeyToLocalStorage('libertoSkipped', true);
    } else {
      saveKeyToLocalStorage('libertoSkipAttempt', true);
    }
  }

  if (action.type === actionTypes.LIBERTO_FAIL) {
    const storeState = store.getState();
    const {
      libertoFailAttempt,
    } = getPersistentItem(storeState.loan.id);

    if (libertoFailAttempt) {
      saveKeyToLocalStorage('libertoFailAttempt', 'error');
    } else {
      saveKeyToLocalStorage('libertoFailAttempt', true);
    }
  }

  if (action.type === actionTypes.SAVE_LIBERTO_SUCCESS) {
    saveKeyToLocalStorage('libertoSuccess', true);
  }

  if (action.type === actionTypes.VALIDATE_OTP_SUCCESS) {
    saveKeyToLocalStorage('pinSuccess', true);
  }

  if (action.type === actionTypes.SUBMIT_SUCCESS) {
    saveKeyToLocalStorage('dueDateSet', true);
  }

  if (action.type === actionTypes.START_FINPASS) {
    saveKeyToLocalStorage('finpassStarted', true);
  }

  if (action.type === actionTypes.FINISH_FINPASS) {
    saveKeyToLocalStorage('finpassSuccess', true);
  }

  if (
    action.type === actionTypes.SET_CZ_INCOME_VERIFICATION_WAY
    || action.type === actionTypes.SKIP_CZ_INCOME_VERIFICATION
  ) {
    saveKeyToLocalStorage('incomeVerificationWay', action.data.incomeVerificationWay);
  }

  if (
    action.type === actionTypes.SET_CZ_IDENTITY_VERIFICATION_WAY
    || action.type === actionTypes.SKIP_CZ_IDENTITY_VERIFICATION
  ) {
    saveKeyToLocalStorage('identityVerificationWay', action.data.identityVerificationWay);
  }

  if (action.type === actionTypes.POST_IDENTITY_DOCUMENTS_SUCCESS) {
    saveKeyToLocalStorage('identityDocumentsUploadSuccess', true);
  }

  return next(action);
};

export default loggerMiddleware;
